<template>
    <transition name="snackbar-slide">
        <v-card class="h-full rounded-lg custom-snackbar" :color="resource.cardColor" absolute dark>
            <v-card-title class="d-flex justify-space-between">
                <span class="text-h6 font-weight-light snackbar-title">
                    <v-icon left>{{ resource.titleIcon }}</v-icon>{{ resource.titleMessage }}</span>

                <v-spacer />
                <v-icon right class="close-button" @click="closeSnackBar()">mdi-close</v-icon>
            </v-card-title>

            <v-card-text class="text-h6 font-weight-bold" style="color: white;" v-if="resource.bodyMessage">
                <small>
                    {{ resource.bodyMessage }}
                </small>
            </v-card-text>
        </v-card>
    </transition>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
    export default {
        data() {
            return {
                
            }
        },

        computed:{
        ...mapGetters({
                resource: "getSnackBarData"
            }),
        },

        methods:{
            ...mapActions([
                "changeSnackBarData"
            ]),

            closeSnackBar(){
                this.changeSnackBarData({
                    status: false,
                    type: '', 
                    titleMessage: '',
                    bodyMessage: '',
                    cardColor: '',
                    titleIcon: '',
                    resource: 'só teste'
                })
            }
        }
    }
</script>
<style scoped>
.v-card__title {
  flex-wrap: nowrap !important;
}

.custom-snackbar {
  width: 500px;
  position: fixed;
  bottom: 4px;
  right: 20px;
  z-index: 9999;
}

.snackbar-slide-enter-active {
  transition: all 0.4s cubic-bezier(0.22, 1, 0.36, 1);
}

.snackbar-slide-leave-active {
  transition: all 0.25s ease-in;
}

.snackbar-slide-enter,
.snackbar-slide-leave-to {
  transform: translateX(120%) scale(0.95);
  opacity: 0;
}

.snackbar-title {
  color: white;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
}

.close-button {
  cursor: pointer;
  flex-shrink: 0;
}

@media (max-width: 600px) {
  .custom-snackbar {
    width: calc(100vw - 20px);
    right: 10px;
    left: 10px;
  }
}
</style>